import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { KundenGruppesService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [KundenGruppesService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class KundenGruppesServiceModule {}
